import React, { Component } from "react";
import { Grid, Loader, Icon, Button, Checkbox, Dropdown } from "semantic-ui-react";
import get from "lodash/get";
import axios from "axios";
import ImporterForm from "./importerForm";
import EntryTypeForm from "./entryType";
//import BondInfoForm from './bondInfoForm'
import TransportationForm from "./transportationForm";
import BolAwbForm from "./bolAwbForm";
import ContainerizedShipmentForm from "./containerizedShipmentForm";
import EngineBolForm from "./engineBolForm";
import InvoiceForm from "./merchandiseForm";
import UserFees from "./userFees";
import BondInfoFormTwo from "./bondInfoFormTwo";
import ReconPageForm from "./reconPageForm";
import DeclarationSection from "./declarationSection";
import { updateAndSaveTotals } from "../actions/DescriptionOfMerchandiseActions.js";
import { getBrokerShipmentList } from "../../actions/searchContextActions";
import Toast from "./Toast";
import store from "../store";
import Warning from "./Warnings/Warning";
import { getQueryVariable } from "../../apiCalls/jobInfo";
import {
  getEntrySummaryForm,
  getVoluntaryPGAData,
  getCarrierCode_oo,
  getDropdownValues,
  getCountryList,
  getSpecialProgramList,
  getUSStateList,
  getUnitList,
  getModeOfTransportList,
  getEntryTypeList,
  getAllCurrencyCodes,
  getShipmentNotes,
  getSCACList,
  checkEarlyBillingPreference,
  getUnaggregatedShipment,
  getAggregationRelationships,
} from "../api/getEntrySummaryData";
import { assignValues } from "./util/assignValues";
import * as actionCreators from "../actions";
import { connect } from "react-redux";
import { dropdownResponse } from "./util/dropdownResponse";
import {
  checkDropdownResponse,
  checkEntrySummaryResponse,
} from "./util/reponseHandler";
import {
  cargoReleaseUpdateFields,
  cargoReleaseStandaloneUpdateFields,
  entryUpdateFields,
} from "../util/supportedFields";
import _ from "lodash";
import { getJobWheels } from "../../../src/util/index";
import Notes from "./NotesTab";
import Journey from "../../commonComponents/Journey/index";
import { ReloadContext } from "./ReloadContext";

for (let iii = 0; iii < 5000; iii++) {
  setTimeout(() => {
    for (var item of document.getElementsByTagName("input")) {
      if (
        !item ||
        (item.classList.value + "").indexOf("VALIDATION_FORM_LISTENER") >= 0
      )
        continue;
      item.classList.add("VALIDATION_FORM_LISTENER");
      if (
        item.parentElement.classList.value &&
        item.parentElement.classList.value.indexOf("dropdown") >= 0
      )
        continue;
      item.addEventListener("blur", (e) => {
        setTimeout(function () {
          document.getElementById("VALIDATE_FORM_BUTTON") &&
            document.getElementById("VALIDATE_FORM_BUTTON").click();
        }, 20);
      });
    }
  }, 10000 * iii);
}

class EntrySummaryForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fullDataResponse: {},
      data: null,
      laceyActData: null,
      expandbutton: true,
      laceyActOpen: false,
      activeAccordianIndex:
        parseInt(localStorage.getItem("lastTabChoseb", 0)) || 0,
      errorMessage: window.errorMessage,
      showallerrors: false,
      drawerIsOpen: false,
      hideError: true,
      showFullDataResponse: false,
      shownHeaderAwbBolItems: {
        BondInfoFormTwo: true,
        Reconformxyz: true,
        BolAwbForm: true,
        TransportationForm: true,
        EntryTypeForm: true,
        IRDeferredTax: true,
        taReconIndicator: true,
        ContainerizedShipmentForm: true,
        EngineBolForm: true,
      },
    };


    this.setActiveAccordianIndex = this.setActiveAccordianIndex.bind(this);
    this.setActiveAccordianIndex = this.setActiveAccordianIndex.bind(this);
    this.toggleDrawerOpen = this.toggleDrawerOpen.bind(this);
    this.createEntrySummary = this.createEntrySummary.bind(this);
    this.isDisabled = this.isDisabled.bind(this);
    this.hideErrorList.bind(this);
    this.showErrorList.bind(this);

    this.rndStyle = {
      backgroundColor: "rgb(245, 245, 245)",
      borderRadius: "5px",
      zIndex: "10000000000",
      padding: "0px",
      border: "1.5px solid #bbbbbb",
      overflow: "scroll",
      overscrollBehavior: "contain",
      overflowX: "hidden",
      position: "fixed",
      top: "180px",
      cursor: "auto",
    };
    const kxUserBasicInfo = get(props, "kxUserBasicInfo", {});




    if (window.shipmentCountry == "US") {
      document.body.classList.remove("CA");
      document.body.classList.add("US");
    }
  }

  getLabel = (customersConnected = [], shipId) => {
    const customerCode = shipId.split("-")[1]
    const customer = customersConnected.filter(customer => customer.customerCode).find(customer => customer.customerCode = customerCode)
    switch (customer?.irTaxIndicator) {
      case "CONVENTIONAL_IR_TAX": return "Conventional Deferral"
      case "ELECTRONIC_FUND_TRANSFER_IR_TAX": return "Electronic Fund Transfer"
      case "TAX_NONE": return "None"
      default: return "Disabled"
    }
  }

  validateForm_zz(instant) {
    if (instant) {
      this.props.intializeWarnings(store.getState(), this.props);
      return;
    }
    // (window.pscShipmentId && document.getElementById(`card-${window.shipmentId}`)) && document.getElementById(`card-${window.shipmentId}`).click();
  }

  setActiveAccordianIndex(index) {
    // if (index === this.state.activeAccordianIndex) {
    //   this.setState({
    //     activeAccordianIndex: index + 1
    //   })
    // } else {
    this.props.intializeWarnings(store.getState(), this.props);
    this.setState({
      activeAccordianIndex: index,
    });
    // }
  }

  componentDidMount() {
    if(window.GLOBAL_MAIN_TOKEN_KXBROKERTOKEN == 'kxEngineBrokerToken' && this.props.shipId?.startsWith("KX-")){
      return;
    }  
    checkEarlyBillingPreference(this.props.shipId)
      .then(res => {
        if (res.data.eventMessage.isEarlyBillingEnabled && res.data.eventMessage.isEarlyBillingEnabled == true) {
          sessionStorage.setItem("earlyBilling", 'true')
        }
        else {
          sessionStorage.setItem("earlyBilling", 'false')
        }
        if (res.data.eventMessage.isChargeCreated && res.data.eventMessage.isChargeCreated == true) {
          sessionStorage.setItem("isChargeCreated", 'true')
        }
        else {
          sessionStorage.setItem("isChargeCreated", 'false')
        }
      })
   
    this.createEntrySummary();
  }


  swtichToPSCParent(shipment_type) {
    this.setState({ PSC_PARENT: true });
    this.createEntrySummary("PSC_PARENT", shipment_type);
  }
  componentDidUpdate(prevProps) {
    let { brokerJobList, currentJobData } = this.props;
    // If shipmentId or read state changes, reload the form

    let hasACurrentJob = !!(brokerJobList && brokerJobList.length > 0 && (brokerJobList || []).find((item) => get(item, 'shipmentId', '') === get(currentJobData, 'shipmentId', '')));

    let sameShipmentDifferentUpdateType = (this.props.shipId === prevProps.shipId &&
      this.props.updateType !== prevProps.updateType && hasACurrentJob);
    if (this.props.shipId !== prevProps.shipId) {
      checkEarlyBillingPreference(this.props.shipId)
        .then(res => {
          if (res.data.eventMessage.isEarlyBillingEnabled && res.data.eventMessage.isEarlyBillingEnabled == true) {
            sessionStorage.setItem("earlyBilling", 'true')
          }
          else {
            sessionStorage.setItem("earlyBilling", 'false')
          }
          if (res.data.eventMessage.isChargeCreated && res.data.eventMessage.isChargeCreated == true) {
            sessionStorage.setItem("isChargeCreated", 'true')
          }
          else {
            sessionStorage.setItem("isChargeCreated", 'false')
          }
        })
    }
    if (this.props.shipId !== prevProps.shipId || sameShipmentDifferentUpdateType) {
      // this.props.toggleLaceyAct(null, false);
      // this.props.toggleTSCA(null, false);
      this.props.setFormLoaded(false, this.props.shipId, "test");
      this.createEntrySummary();
    } else if (this.props.pscData && this.props.pscData.trigger_PSC) {
      store.dispatch(
        getBrokerShipmentList(this.createEntrySummary, this.props.unTriggerPSC)
      );
      this.props.setFormLoaded(false, this.props.shipId, "test");
      // setTimeout(()=>{
      //   this.createEntrySummary();
      //   this.props.unTriggerPSC();
      // }, 2000)
    }
    // If expand prop changes due to print referencing the same store, update this prop.
    if (prevProps.expandAll !== this.props.expandAll) {
      this.props.setAnyFormValue("expandAll", this.props.expandAll || false);
    }
  }
  toggleDrawerOpen() {
    this.setState({ drawerIsOpen: !this.state.drawerIsOpen });
  }

  createEntrySummary(PSC_PARENT, shipment_type) {
    const createEntrySummaryCopy = this.createEntrySummary;
    let {
      shipId,
      initializeValuesBondInfo,
      initializeValuesImporter,
      initializeCarrierCodeList,
      initializeValuesEntryType,
      initializeValuesRecon,
      initializeValuesTransportation,
      initializeValuesBOL,
      initializeValuesPSC,
      initializeValuesDescriptionOfMerchandise,
      initializeValuesDeclarationSection,
      initializeValuesPscChain,
      initializeValuesFieldValidation,
      intializeWarnings,
      initializeValuesServerWarnings,
      initializeDropDowns,
      setFormLoaded,
      getEntrySummarySuccess,
      expandAll,
      setAnyFormValue,
      updateType,
      updateTypes,
      currentJobData
    } = this.props;
    let functionLevelState = this?.props?.topLevelStateX;
    if(PSC_PARENT?.isChainMode){
        shipId = PSC_PARENT.shipId
    } else if (PSC_PARENT) {
      shipId = "PSC_PARENT" + shipId;
    } else {
      this.setState({ PSC_PARENT: false });
    }
    setFormLoaded(false, shipId, "test");
    getEntrySummarySuccess(false);
    // Development Enviropnemnt - npm run start
    if (window._env_.REACT_APP_ES_ENV === "TEST_ENV") {
      shipId = "KX-A4I5-519";
    }

    function masterError() {
      return dropdownResponse;
    }
    function entryFormError(error) {
      setFormLoaded(false, shipId, "test", error);
    }
    let parentThisxx = this;
    axios
      .all([
        getEntrySummaryForm(shipId).catch((err) => entryFormError(err)),
        //   getShipmentNotes(shipId).catch((err) => entryFormError(err)),
        getDropdownValues().catch(masterError),
        getCountryList().catch(masterError),
        getSpecialProgramList().catch(masterError),
        getUSStateList().catch(masterError),
        getUnitList().catch(masterError),
        getEntryTypeList().catch(masterError),
        getVoluntaryPGAData(),
        getAllCurrencyCodes(),
        // getSCACList().catch(masterError)
      ])
      .then(
        axios.spread(async function (
          dataResponse,
          // getShipmentNotesResponse,
          dropdownValuesResponse,
          getCountryListResponse,
          getSpecialProgListResponse,
          getUSStateListResponse,
          getUnitListResponse,
          getEntryTypeListResponse,
          voluntaryPGAData,
          allCurrencyCodes,
          // getSCACListResponse
        ) {
          if(localStorage.getItem("useAggregateOnUi") != "true" && dataResponse?.data?.eventMessage?.useAggregated == "true" &&
            dataResponse?.data?.eventMessage?.descriptionOfMerchandise){
            let responseWithUnaggregated = await getUnaggregatedShipment(shipId);
            console.log('responseWithUnaggregated: ', responseWithUnaggregated);
            dataResponse.data.eventMessage.descriptionOfMerchandise = responseWithUnaggregated?.data?.eventMessage || {};
          }
          let merchandiseAggregationRelList = []
          if(dataResponse?.data?.eventMessage?.useAggregated == "true"){
            
            const aggregationResponse = await getAggregationRelationships(shipId);
            merchandiseAggregationRelList = aggregationResponse?.data?.eventMessage?.merchandiseAggregationRelList;
           }

          

          
          window.customerEmail =  _.get(dataResponse,"data.eventMessage.entryTypeInfo.customerEmail") || window.customerEmail;
          
          if (window._env_.REACT_APP_ES_ENV === "TEST_ENV") {
            shipId = "KX-A4I5-519";
            window.customerEmail = "lifestyle@shipment.klearexpress.com";
          }

          for (let invoice of _.get(dataResponse, "data.eventMessage.descriptionOfMerchandise.entrySummaryInvoices", [])) {
            if (!invoice) continue;
            if (!invoice.currencyExchangeInfo || (!invoice.currencyExchangeInfo.exchangeRate && !invoice.currencyExchangeInfo.fromIsoCurrencyCode)) {
              invoice.currencyExchangeInfo = {
                ...(invoice.currencyExchangeInfo || {}),
                exchangeRate: "1",
                fromIsoCurrencyCode: "USD",
              }
            }
          }
          
          window.brokerId = dataResponse.data.eventMessage.brokerId;
          
          const subCustomerCodeForShipment = dataResponse?.data.eventMessage?.entryTypeInfo?.subCustomerCode;
          if(subCustomerCodeForShipment && window.GLOBAL_PARAMETER_OF_SUBCUSTOMERS){
            let findEntity = (window.GLOBAL_PARAMETER_OF_SUBCUSTOMERS?.data?.eventMessage?.entity  || []).find((ennn)=>ennn?.entityDetails?.code ==subCustomerCodeForShipment);
            if(findEntity){
              window.brokerId = findEntity.entityDetails.entityGuid;
              dataResponse.data.eventMessage.brokerId = findEntity.entityDetails.entityGuid;
            } 
          }
          //GET_ENTRY_SUMMARY_FORM
          const isEngineForm = window.GLOBAL_MAIN_TOKEN_KXBROKERTOKEN == 'kxEngineBrokerToken';
          let shipmentIdInHeader = document.getElementById("shipmentIdInHeaderx") && document.getElementById("shipmentIdInHeaderx").value;
          if (!isEngineForm && shipmentIdInHeader && (shipmentIdInHeader.trim().toUpperCase() != _.get(dataResponse, "data.eventMessage.shipmentId", "").trim().toUpperCase())) {
            if(parseInt(_.get(dataResponse, "data.eventMessage.code", 0))<400){//we should show error messages too!
              return;//a slow get_entry_summary has loaded, and it is trying to overwrite the wrong shipment!
            }
          }

          parentThisxx.setState({ fullDataResponse: dataResponse });
          document.getElementById("RERENDER__BUTTONS") && document.getElementById("RERENDER__BUTTONS").click();
          setTimeout(() => {
            document.getElementById("VALIDATE_FORM_BUTTON") &&
              document.getElementById("VALIDATE_FORM_BUTTON").click();
            // document.getElementById(`card-${window.shipmentId}`) && document.getElementById(`card-${window.shipmentId}`).click();
          }, 5000);
          setTimeout(() => {
            document.getElementById("clickCI__0") &&
              document.getElementById("clickCI__0").click();

          }, 100);

          // ADD EMPTY SCENARIOs
          checkDropdownResponse(
            getSpecialProgListResponse
          ).data.eventMessage.itemList.unshift({
            id: "NONE",
            description: "",
            ediCode: "NONE",
          });
          checkDropdownResponse(
            getUnitListResponse
          ).data.eventMessage.itemList.unshift({
            id: "NONE",
            description: "",
            ediCode: "NONE",
          });
          let conversionlistnj = {
            "080.012": {
              value: "080.012",
              description:
                "Prescription health or medical product for human use that is the subject of an approved new drug application, abbreviated new drug application, or biologics license application",
            },
            "100.000": {
              value: "100.000",
              description: "Importation for Personal Use",
            },
            "130.000": {
              value: "130.000",
              description:
                "For Consumer Use as a Non- Food Product – Over the Counter (OTC)",
            },
            150.007: {
              value: "150.007",
              description:
                "Active Pharmaceutical Ingredient / Bulk Drug Substance for processing into a pharmaceutical product",
            },
            150.013: {
              value: "150.013",
              description:
                "Active Pharmaceutical Ingredient / Bulk Drug Substance to be used for Pharmacy Compounding",
            },
            150.017: {
              value: "150.017",
              description:
                "Importation of a drug component (API) for use in a medical product regulated under a device (CDRH) application type (e.g., for use in a PMA/510(k) drug-device combination product)",
            },
            155.009: {
              value: "155.009",
              description:
                "Importation of a drug constituent part (drug product) for use in a medical product regulated under a device (CDRH) application type (e.g., for use in a PMA/510(k) drug-device combination product)",
            },
            180.009: {
              value: "180.009",
              description:
                "Chemical for research and development of a pharmaceutical product – subject of an Investigational New Drug application (IND), including Placebos",
            },
            180.017: {
              value: "180.017",
              description:
                "Chemical for research and development of a pharmaceutical product – laboratory testing only, no human/animal use",
            },
            180.018: {
              value: "180.018",
              description:
                "Chemical for research and development of a pharmaceutical product –investigational use in animals",
            },
            180.026: {
              value: "180.026",
              description:
                "Finished drug or API intended for use in an in vivo bioequivalence or bioavailability study in humans that qualifies under 21 CFR 320.31 for an exemption from the Part 312 requirements; or, finished drug intended for use in clinical investigation in humans that qualifies for an exemption from Part 312 requirement",
            },
            "920.000": { value: "920.000", description: "US Goods Returned" },
            "970.000": { value: "970.000", description: "Import for Export" },
            "980.000": {
              value: "980.000",
              description:
                "For Other Use: (APIs or Finished Drugs not elsewhere classified)Source Type Code39 - Country of Production30 - Country of Source (for a component)Party Entity Codes16 - DUNS47 - FEIAffirmations of ComplianceREG - Drug Registration NumberDLS - Drug Listing NumberIND - Investigational New Drug NumberERR - Entry Review RequestedPLR - Used to identify the shipment as a PLAIR import shipment",
            },
            "150.000": {
              value: "150.007",
              description:
                "For Commercial Processing as a NonFood Product",
            },
            "110.000": {
              value: "110.000",
              description:
                "For Public Exhibition or Display as a Non-Food Product",
            }, 
            "130.033": {
              value: "130.033",
              description:
                "Inactive ingredients and intermediates for use in a pharmaceutical product",
            },
            "155.000": {
              value: "155.000",
              description:
                "For Commercial Assembly as a Non-Food Product",
            },
            "180.000": {
              value: "180.000",
              description:
                "For Research and Development as a NonFood Product",
            },
           "130.029": {
              value: "130.029",
              description:
                "Chemical Substance for use in a food additive",
            },
          };
          let finalintendedusecodes = [];
          let intendedUseCodesList =
            dropdownValuesResponse.data.eventMessage.intendedUseCodesList;
          if (intendedUseCodesList) {
            for (var number of dropdownValuesResponse.data.eventMessage
              .intendedUseCodesList) {
              if (conversionlistnj[number]) {
                finalintendedusecodes.push(conversionlistnj[number]);
              } else {
                console.error("UNKNOWN ID " + number);
              }
            }
          }
          initializeDropDowns({
            bolTypeList: dropdownValuesResponse.data.eventMessage.bolTypeList,
            NotesDescriptionCodes: dropdownValuesResponse.data.eventMessage.NotesDescriptionCodes,
            userFeeCodes: dropdownValuesResponse.data.eventMessage.userFeeCodes,
            permitTypeCodesList:
              dropdownValuesResponse.data.eventMessage.permitTypeCodesList,
            aocCodes: dropdownValuesResponse.data.eventMessage.aocCodes,
            quantityUnitsList:
              dropdownValuesResponse.data.eventMessage.quantityUnitsList,
            temperatureQualifierCodes:
              dropdownValuesResponse.data.eventMessage
                .temperatureQualifierCodes,
            intendedUseCodesList: finalintendedusecodes,
            govtAgencyProcessingCodes:
              dropdownValuesResponse.data.eventMessage
                .govtAgencyProcessingCodes,
            headerPartyType:
              dropdownValuesResponse.data.eventMessage.headerPartyType,
            reconciliationIssueCodesList:
              dropdownValuesResponse.data.eventMessage
                .reconciliationIssueCodesList,
            statementPaymentTypeList:
              dropdownValuesResponse.data.eventMessage.statementPaymentTypeList,
            weightUnitsList:
              dropdownValuesResponse.data.eventMessage.weightUnitsList,
            constituentElemUomList:
              dropdownValuesResponse.data.eventMessage.constituentElemUom,
            functionsPassed_i : {
              createEntrySummary: createEntrySummaryCopy,
            },
            uomList: dropdownValuesResponse.data.eventMessage.uomList,
            outerUomList: dropdownValuesResponse.data.eventMessage.outerUomList,
            sourceTypeCodes:
              dropdownValuesResponse.data.eventMessage.sourceTypeCodes,
            entityIdTypes:
              dropdownValuesResponse.data.eventMessage.entityIdTypes,
            USStatesList: checkDropdownResponse(getUSStateListResponse).data
              .eventMessage.itemList,
            internalRevenueAccountingClassCodesList: dropdownValuesResponse.data.eventMessage.internalRevenueAccountingClassCodesList,
            countryList: checkDropdownResponse(getCountryListResponse).data
              .eventMessage.itemList,
            splProgramList: checkDropdownResponse(getSpecialProgListResponse)
              .data.eventMessage.itemList,
            unitList: checkDropdownResponse(getUnitListResponse).data
              .eventMessage.itemList,
            modeOfTransportList:
              dropdownValuesResponse.data.eventMessage.modeOfTransportList,
            importerAdditionalDeclarationTypeCodesList:
              dropdownValuesResponse.data.eventMessage.importerAdditionalDeclarationTypeCodesList,
            entryTypeList: checkDropdownResponse(getEntryTypeListResponse).data
              .eventMessage.itemList,
            tradeProgramCountryMapping:
              dropdownValuesResponse.data.eventMessage
                .tradeProgramCountryMapping,
            allVoluntaryPGAs: (voluntaryPGAData.data.eventMessage.pgaMetadataList || []),
            allCurrencyCodes: allCurrencyCodes.data.eventMessage,
            // SCACList: checkDropdownResponse(getSCACListResponse).data
            //   .eventMessage.itemList
          });
          // Populate Data
          //formDisabled init here!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
          //formDisabled init here!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
          //formDisabled init here!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
          //formDisabled init here!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
          let formdisabledvalue = getQueryVariable("disabledFromEngine")=="true" || 
            functionLevelState?.state?.disableEntireFormX ||(updateType === _.get(updateTypes, "entryUpdate") ||
              updateType === _.get(updateTypes, "combined")
              ? false
              : updateType);
          setAnyFormValue("formDisabled", formdisabledvalue);
          setAnyFormValue("expandAll", expandAll || false);
          if (checkEntrySummaryResponse(dataResponse)) {
            let value = assignValues(dataResponse.data.eventMessage);
            // useAggregated to redux
            value.descriptionOfMerchandise.useAggregated = dataResponse?.data?.eventMessage?.useAggregated
            
            value.entryTypeInfo.merchandiseAggregationRelList = merchandiseAggregationRelList;
            value.shipmentId = shipId;
            initializeValuesImporter(value.importer);
            window.shipmentETA = value.transportInfo.arrivalDate.epochs || -999
            initializeValuesBondInfo(value.bondInfo);
            initializeValuesEntryType(value.entryTypeInfo);
            initializeValuesRecon(value.reconInfo);
            initializeValuesTransportation(value.transportInfo);
            initializeValuesBOL(value.bolInfo);
            initializeValuesDescriptionOfMerchandise(
              value.descriptionOfMerchandise
            );
            let pscShipmentId = value.pscShipmentId;
            if((value?.pscChain?.activeChildId||"").includes("--") && shipmentIdInHeader == value?.pscChain?.activeChildId){
              pscShipmentId=value?.pscChain?.activeChildId
            }
            if(value?.pscChain?.child){
              value.pscChain.child = value.pscChain.child.filter(a=>!a.archived);
            }
            initializeValuesPSC(value.psc, pscShipmentId);
            initializeValuesDeclarationSection(value.declarationSection);
            initializeValuesPscChain(value.pscChain);
            intializeWarnings(store.getState());
            initializeValuesFieldValidation(value.fieldValidations);
            let serverwarnobj = { serverwarnings_tm: _.get(dataResponse, "data.eventMessage.warnings.warnings", []) };
            initializeValuesServerWarnings(serverwarnobj)
            window.shipmentId = shipId;
            window.updateAvailable = value.updateAvailable || null;
            setFormLoaded(true, shipId, "test");
            setTimeout(() => {
              getEntrySummarySuccess(true, shipment_type);
            }, 1000);
          } else {
            console.error("ERROR GET_ENTRY_SUMMARY");
            setFormLoaded(false, shipId, "test");
          }
          store.dispatch(
            updateAndSaveTotals(
              dataResponse.data.eventMessage.hmf.fee,
              dataResponse.data.eventMessage.mpf.fee,
              dataResponse.data.eventMessage.duty,
              dataResponse.data.eventMessage.fee,
              dataResponse.data.eventMessage.tax,
              dataResponse.data.eventMessage.additionalDuties,
              dataResponse.data.eventMessage.bondedAdDutyAmt,
              dataResponse.data.eventMessage.bondedCvdDutyAmt,
              dataResponse.data.eventMessage.cashAdDutyAmt,
              dataResponse.data.eventMessage.cashCvdDutyAmt,
              dataResponse.data.eventMessage.grandTotal,
              dataResponse.data.eventMessage
            )
          );
        })
      )
      .catch((err) => {
        console.error("ERROR GET_ENTRY_SUMMARY", err);
        setFormLoaded(false, shipId, "test", err);
        parentThisxx.setState({ formLevelError: err });
      });

    getCarrierCode_oo().then((data) => {
      let carrierCodeList = _.get(data, "data.eventMessage.carrierCodes");
      if (!carrierCodeList) return;
      for (var ccode of carrierCodeList) {
        ccode.key = ccode.twoLetterCode + " AA " + ccode.companyName;
        ccode.text = ccode.twoLetterCode + ": " + (ccode.companyName + "");
        ccode.description = ccode.companyName;
        ccode.value = ccode.twoLetterCode;
        ccode.id = ccode.twoLetterCode;
      }
      initializeCarrierCodeList({ carrierCodeList: carrierCodeList });
    });
  }

  maxErrorsShownToggle() {
    this.setState({ showallerrors: !this.state.showallerrors });
  }

  isDisabled(fieldId, defaultReturn = false, alternateProps) {
    if(this?.props?.topLevelStateX?.state?.disableEntireFormX){
      return true;
    }
    if(getQueryVariable("disabledFromEngine")=="true"){
      return true;
    }
    let shipmentCountry = window.shipmentCountry || "US";
    const {
      updateTypes,
      updateType,
      currentJobData,
      kxUserBasicInfo,
      isBrokerKnAdmin,
      entryTypeValues,
    } = this.props || alternateProps || {};


    //console.log(updateType , "updateType")
    //  let isValidUser = false;
    //  let jobWheel = getJobWheels(shipmentCountry, currentJobData);
    //  let bhHouseKey = jobWheel['SHIPMENT_BROKER_HOUSE_PROCESS'] ? jobWheel["SHIPMENT_BROKER_HOUSE_PROCESS"].value.state : null;

    //  if(isBrokerKnAdmin || bhHouseKey === "STATE_BH_ASSIGNED") {
    //     return true
    //   }

    //   if(currentJobData && currentJobData.brokerGuid){
    //     isValidUser = get(kxUserBasicInfo,'userGuid','') === get(currentJobData,'brokerGuid','')
    //   }
    // && !isValidUser
    //cr update es update esupdate crupdate
    if (updateType) {

      if (updateType === true) {
        return true;
      } else if (updateType === updateTypes.cargoReleaseUpdate) {
        if (entryTypeValues.crStandaloneStatus == "in_process") {
          if (Object.keys(cargoReleaseStandaloneUpdateFields).includes(fieldId)) {
            return !cargoReleaseStandaloneUpdateFields[fieldId];
          }
          return false;
        } else if (cargoReleaseUpdateFields[fieldId]) {
          return false;
        } else {
          return true;
        }
      } else if (updateType === updateTypes.entryUpdate) {
        if (entryUpdateFields[fieldId]) {
          return false;
        } else {
          return true;
        }
      }
      //return false;
    }
    return defaultReturn;
  }

  hideErrorList = () => {
    if (this.state.showallerrors) {
      this.maxErrorsShownToggle();
    }
    this.setState({ hideError: true });
    setTimeout(()=>{
      this.setState({});
    },1);
  };

  showErrorList = () => {
    this.setState({ hideError: false });
    setTimeout(()=>{
      this.setState({});
    },1);
  };

  getMerchandiseIds = () => {
    let merchandiseIds = [];
    let invoiceData = this.props.invoiceData.slice();
    invoiceData.map((_item, _index) => {
      let merchandiseData = _item.merchandiseLineItems;
      merchandiseData &&
        merchandiseData.map((item, index) => {
          merchandiseIds.push({ invoiceIndex: _index, merchandiseId: item.merchandiseId, lineIndex: index });
        });
    })

    return merchandiseIds;
  };
  censusWarningsList = (CW) => {
    if (CW) {
      let merchandiseIds = this.getMerchandiseIds();
      const censusWarningMap = {
        "27A": {
          fieldName: "countryOfOrigin",
          combinedField: "countryOfOrigin",
        },
        "27B": {
          fieldName: "additionalQuantity",
          combinedField: "manifestQuantity,additionalQuantity",
        },
        "27C": {
          fieldName: "manifestQuantity",
          combinedField: "manifestQuantity,enteredValue",
        },
        "27D": {
          fieldName: "manifestQuantity",
          combinedField: "manifestQuantity,enteredValue",
        },
        "27F": {
          fieldName: "additionalQuantity",
          combinedField: "additionalQuantity,enteredValue",
        },
        "27M": {
          fieldName: "additionalQuantity",
          combinedField: "manifestQuantity,additionalQuantity",
        },
        "27H": {
          fieldName: "lineItemWeight",
          combinedField: "grossWeight",
        },
        "27I": {
          fieldName: "lineItemWeight",
          combinedField: "grossWeight",
        },
        "27J": {
          fieldName: "enteredValue",
          combinedField: "charges,enteredValue",
        },
        "27P": {
          fieldName: "enteredValue",
          combinedField: "charges,enteredValue",
        },
        "27Q": {
          fieldName: "charges",
          combinedField: "charges",
        },
        "27G": {
          fieldName: "modeOfTransport",
          combinedField: "modeOfTransport",
        },
      };
      //  let cnt = 0;
      //  let totalWarning = Object.keys(CW).length;
      return Object.keys(CW).map((item, idx) => {
        let cwData = CW[item];
        let mapKey = item.split("_")[0];
        // if(!this.state.cwCheck && !(cwData["overrideCodeUsed"] || cwData["valueChanged"] ===1)){
        //   this.setState({"cwCheck": true}, ()=>{
        //     this.props.getEntrySummarySuccess(false);
        //   })
        // }
        // if(cwData["overrideCodeUsed"] || cwData["valueChanged"] ===1){
        //   cnt++;
        //   if(cnt === totalWarning){
        //     this.setState({"cwCheck": false}, ()=>{
        //       this.props.getEntrySummarySuccess(true);
        //     })
        //   }
        // }
        if (!censusWarningMap[mapKey]) {
        }
        let lineItemIndex = 0;
        let invoiceIndex = 0;
        if (cwData) {
          merchandiseIds.map((item) => {
            if (item.merchandiseId === cwData["merchandiseId"]) {
              lineItemIndex = item.lineIndex;
              invoiceIndex = item.invoiceIndex;
            }
          });
          return (
            {
              lineItemIndex: lineItemIndex,
              invoiceIndex: invoiceIndex,
              reacthtmlobject: <Warning
                key={idx+censusWarningMap[mapKey]["fieldName"]+" "+lineItemIndex+cwData["merchandiseId"]}
                fieldName={censusWarningMap[mapKey]["fieldName"]}
                combinedField={censusWarningMap[mapKey]["combinedField"]}
                code={mapKey}
                warningindexk={idx}
                merchandiseId={cwData["merchandiseId"]}
                warningValue={``}
                invoiceIndex={invoiceIndex || 0}
                lineItemIndex={lineItemIndex}
                dutyItemIndex={null}
              />
            }
          );
        }
      });
    }
  };

  render() {

    const {
      tariffsLoader,
      formLoaded,
      setFormValues,
      newValue,
      setINPUTID,
      penClicked,
      fieldName,
      formError,
      rbCounterID,
      errorMessage,
      expandAll,
      shipmentCountry,
      currentJobData,
      kxUserBasicInfo,
      brokerJobList,
      pscChainRawResponse,
      bolInfoValues,
    } = this.props;
    let responseObjectff = _.get(this.state, "fullDataResponse.data.eventMessage", {});
    let shipmentId = responseObjectff?.shipmentId;
    const isAPscShipment = (pscChainRawResponse?.child || []).map(aaa=>aaa.humanReadableId).includes(shipmentId);

    
    let toggleButton = (title, whattotoggle) => {
      return <div style={{ marginTop: '6px', marginBottom: '6px' }}
        className="stepNumber"
        onClick={() => {
          let shownHeaderAwbBolItems = this.state.shownHeaderAwbBolItems;
          shownHeaderAwbBolItems[whattotoggle] = !shownHeaderAwbBolItems[whattotoggle];
          this.setState({ shownHeaderAwbBolItems: shownHeaderAwbBolItems })
        }}>
        <Icon
          name={
            this.state.shownHeaderAwbBolItems[whattotoggle]
              ? `minus circle`
              : `plus circle`
          }
        />
        {title}
      </div>
    }

    let totalNumberOfLineItems = 0;
    for(let invoiceX of this.props?.invoiceData||[]){
      totalNumberOfLineItems+=(invoiceX?.merchandiseLineItems||[]).length
    }

    let formTabNameSections = [
      {
        title: "Parties",
        className: "importer",
        warningsName_la: "Parties", //FieldValidationReducer
        form: (props) => (
          <ImporterForm
            pscState={this.props.pscState}
            {...props}
            isAPscShipment={isAPscShipment}
            kxUserBasicInfo={kxUserBasicInfo}
            shipmentCountry={this.props.shipmentCountry}
            currentJobData={this.props.currentJobData}
          />
        ),
      },
      {
        title: "Header",
        className: "bolAwbInfo ",
        warningsName_la: window.GLOBAL_MAIN_TOKEN_KXBROKERTOKEN == "kxEngineBrokerToken"?
          "Transport,Entry,BondValidationTab":
          "Transport,Entry,Bol,BondValidationTab", //FieldValidationReducer
        form: (props) => (
          <>
            <div className="merchandise-line-item">

              {toggleButton('Entry Type', 'EntryTypeForm')}
              {this.state.shownHeaderAwbBolItems['EntryTypeForm'] && <EntryTypeForm
                pscState={this.props.pscState}
                {...props}
                isAPscShipment={isAPscShipment}
                kxUserBasicInfo={kxUserBasicInfo}
                shipmentCountry={this.props.shipmentCountry}
                currentJobData={this.props.currentJobData}
              />}
              <br />
            </div>

            <div className="merchandise-line-item" style={{ paddingTop: '6px !important' }}>
              {toggleButton('Transportation', 'TransportationForm')}
              {this.state.shownHeaderAwbBolItems['TransportationForm'] && <TransportationForm
                pscState={this.props.pscState}
                {...props}
                isAPscShipment={isAPscShipment}
                kxUserBasicInfo={kxUserBasicInfo}
                shipmentCountry={this.props.shipmentCountry}
                currentJobData={this.props.currentJobData}
              />}
            </div>

            <div className="merchandise-line-item bolAwbformEngine" style={{ paddingTop: '6px !important' }}>

              {toggleButton('Bill of Lading', 'BolAwbForm')}
              {this.state.shownHeaderAwbBolItems['BolAwbForm'] && <BolAwbForm
                pscState={this.props.pscState}
                {...props}
                isAPscShipment={isAPscShipment}
                kxUserBasicInfo={kxUserBasicInfo}
                shipmentCountry={this.props.shipmentCountry}
                currentJobData={this.props.currentJobData}
              />
              }
            </div>

            <div className="merchandise-line-item" style={{ paddingTop: '6px !important' }}>

              {toggleButton('Bond Info', 'BondInfoFormTwo')}
              {this.state.shownHeaderAwbBolItems['BondInfoFormTwo'] && <BondInfoFormTwo
                pscState={this.props.pscState}
                {...props}
                isAPscShipment={isAPscShipment}
                kxUserBasicInfo={kxUserBasicInfo}
                shipmentCountry={this.props.shipmentCountry}
                currentJobData={this.props.currentJobData}
              />
              }
            </div>

              <div className="merchandise-line-item" style={{ paddingTop: '6px !important' }}>
                {toggleButton('Recon', 'Reconformxyz')}
                  <ReconPageForm
                    pscState={this.props.pscState}
                    {...props}
                    isAPscShipment={isAPscShipment}
                    kxUserBasicInfo={kxUserBasicInfo}
                    shipmentCountry={this.props.shipmentCountry}
                    currentJobData={this.props.currentJobData}
                    entryTypeValues={this.props.entryTypeValues}
                  />
              </div>
            {
              this.getLabel(this.props.kxUser?.channelConnections?.customersConnected, this.props.shipId) != "Disabled" &&
              <div className="merchandise-line-item" style={{ paddingTop: '6px !important' }}>
                {toggleButton('IR Deferred Tax', 'IRDeferredTax')}
                {this.state.shownHeaderAwbBolItems['IRDeferredTax'] && <div>
                <Checkbox
                  id="IRDeferredTax"
                  className=""
                  label={this.getLabel(this.props.kxUser?.channelConnections?.customersConnected, this.props.shipId)}
                  checked={true}
                  disabled={true} />
                </div>}
              </div>
            }
             <div className="merchandise-line-item" style={{ paddingTop: '6px !important' }}>
                {toggleButton('FTA Recon', 'taReconIndicator')}
                {this.state.shownHeaderAwbBolItems['taReconIndicator'] && <div>
                <Checkbox
                  checked={this.props.reconInfo?.taReconIndicator === "Y"}
                  id="taReconIndicator"
                  className=""
                  label={"Free Trade Agreement"}
                  onChange={(e)=>{
                    const value = e.target.checked ? "Y" : "N/A";
                    let localreconInfo = this.props.reconInfo;
                    if(value === "Y"){
                      localreconInfo.taReconIndicator = value;
                    } else {
                      delete localreconInfo.taReconIndicator; 
                    }
                    this.props.updateEntryTypeField("reconciliationIssueCode", value)
                    let updatedData =  {tradeAgreementReconciliationIndicator: value, taReconIndicator: value, taReconCode:this.props.reconInfo?.taReconCode, reconciliationIssueCode:this.props.reconInfo?.taReconCode}
                    this.props.saveReconField('reconInfo', {entryTypeInfo: updatedData})
                  }}
                  />
                </div>}
              </div>
          </>
        ),
      },








      {
        title: `BOL`,
        className: "bolOnlyInformation ",
        warningsName_la: "Bol", //FieldValidationReducer
        form: (props) => {
          return(
          <>

            <div className="merchandise-line-item" style={{ paddingTop: '6px !important', position: 'relative' }}>

              {toggleButton('Bill of Lading', 'EngineBolForm')}
              {this.state.shownHeaderAwbBolItems['EngineBolForm'] && <EngineBolForm
                entryTransactionStatus={jobWheel?.ENTRY_TRANSACTION_STATUS?.value?.state}
                pscState={this.props.pscState}
                {...props}
                isAPscShipment={isAPscShipment}
                transportationInfo={this.props.transportationInfo}
                kxUserBasicInfo={kxUserBasicInfo}
                shipmentCountry={this.props.shipmentCountry}
                currentJobData={this.props.currentJobData}
              />
              }
            </div>
          </>
        )},
      },
      {
        title: `Container`,
        className: "containerizedShipmentFormOnlyInformation ",
        warningsName_la: "ContainerizedShipmentForm", //FieldValidationReducer
        containerizedOnly: true,
        form: (props) => (
          <>

            <div className="merchandise-line-item" style={{ paddingTop: '6px !important' }}>

              {toggleButton('Containers', 'ContainerizedShipmentForm')}
              {this.state.shownHeaderAwbBolItems['ContainerizedShipmentForm'] && <ContainerizedShipmentForm
                pscState={this.props.pscState}
                {...props}
                isAPscShipment={isAPscShipment}
                kxUserBasicInfo={kxUserBasicInfo}
                shipmentCountry={this.props.shipmentCountry}
                currentJobData={this.props.currentJobData}
              />
              }
            </div>
          </>
        ),
      },







      {
        title: `Line Items`,
        className: "descriptionOfMerchandise",
        warningsName_la: "Merchandise", //FieldValidationReducer
        disableFormBelowThis: this.props.entryTypeValues.useAggregated == "true",
        form: (props) => 
        <ReloadContext.Provider value={{ createEntrySummary: this.createEntrySummary }}>
          <InvoiceForm 
          pscState={this.props.pscState} 
          kxUserBasicInfo={kxUserBasicInfo} 
          shipmentCountry={this.props.shipmentCountry} 
          updateType={this.props.updateType} data={this.props.data} 
          isAPscShipment={isAPscShipment}
          {...props} currentJobData={this.props.currentJobData} 
          refreshESFrom={this.createEntrySummary} 
          validateFormzz={this.validateForm_zz.bind(this)} />
        </ReloadContext.Provider>

      },

      {
        title: `Aggregated`,
        className: "descriptionOfMerchandise",
        disableFormBelowThis: true,
     //   warningsName_la: "Merchandise", //FieldValidationReducer
        form: (props) => 
          <ReloadContext.Provider value={{ createEntrySummary: this.createEntrySummary }}>
          <InvoiceForm 
            pscState={this.props.pscState} 
            isAggregateTab={true}
            kxUserBasicInfo={kxUserBasicInfo} 
            shipmentCountry={this.props.shipmentCountry} 
            updateType={this.props.updateType} data={this.props.data} 
            isAPscShipment={isAPscShipment}
            {...props} 
            currentJobData={this.props.currentJobData} 
            refreshESFrom={this.createEntrySummary} 
            validateFormzz={this.validateForm_zz.bind(this)} />
        </ReloadContext.Provider>

      },

      {
        title: "Sign",
        className: "declarationSection ",
        warningsName_la: "Sign", //FieldValidationReducer
        form: (props) => (
          <DeclarationSection
            pscState={this.props.pscState}
            {...props}
            isAPscShipment={isAPscShipment}
            kxUserBasicInfo={kxUserBasicInfo}
            shipmentCountry={this.props.shipmentCountry}
            currentJobData={this.props.currentJobData}
          />
        ),
      },
      {
        title: "Notes",
        className: "",
        form: (props) => <Notes {...props} shipId={this.props.shipId} fullName={this.props.kxUserBasicInfo.fullName} />,
      },
      {
        title: "Journey",
        className: "",
        form: (props) => <Journey mbol={this.props.currentJobData?.masterBolNumber} mot={props.modeOfTransport} shipmentId={this.props.shipId} />,
      },
    ].filter(sectionX=>
      !(sectionX.containerizedOnly && this.props.currentJobData.modeOfTransport == 'AIR')).filter(sectionX=>
        getQueryVariable("onlyOneShipment") || !["BOL","Container"].includes(sectionX.title)
         ).filter(sectionX=>{
           if(sectionX.title == "Aggregated" && this.props.entryTypeValues.useAggregated != "true") return false;
           return true;
          });;


    let isBrokerKnAdmin =
      get(this.props, "kxUserBasicInfo.typeOfUser", "") === "BROKER_KN_ADMIN";
    for (var onesection of formTabNameSections) {
      if (!this.props.fieldValidation || !this.props.fieldValidation.warnings) {
        onesection.warnings = [];
        continue;
      }
      onesection.warnings = this.props.fieldValidation.warnings.filter(
        (obbo, iiii) => {
          if (obbo.tab == 'ALLTABS') return true;
          //  obbo.tab == onesection.warningsName_la || obbo.tab =='ALLTABS'
          for (let tabname of (onesection.warningsName_la || "").split(",")) {
            if (obbo.tab == tabname) return true;
          }
          return false;
        }
      );
      onesection.warningClassListN = [];
      for (let tabname of (onesection.warningsName_la || "").split(",")) {
        onesection.warningClassListN.push("nameOfWarningTab" + tabname)
      }
    }
    let CW = {};
    const CWlistfromES = (get(this.props, "fieldValidation.census_warnings", []));
    for (let onekey of Object.keys(CWlistfromES || {})) {
      if (CWlistfromES[onekey].isWarningResolved != '1') {
        CW[onekey] = CWlistfromES[onekey]
      }
    }
    const fieldValidationField = get(this.props, "fieldValidation.fields");
    let activeAccordianIndex = parseInt(localStorage.getItem("lastTabChoseb", 0)) || 0;
    //style={{height:'0px',width:'0px',overflow:'ihhden'}}
    if(formTabNameSections && formTabNameSections[activeAccordianIndex] && ["Aggregated", "Line Items"].includes(formTabNameSections[activeAccordianIndex].title) 
      && this.props.entryTypeValues?.useAggregated == "true"
    ){
      activeAccordianIndex = formTabNameSections.findIndex(section => section.title == (localStorage.getItem("useAggregateOnUi") == "true"?"Aggregated":"Line Items"));
    }
    
    let cwStatus = null;
    let removePSCEnding = (shipmentId)=>{
      shipmentId=shipmentId||"";
      if(shipmentId.includes("--")){
        shipmentId = shipmentId.split("--")[0];
      }
      return shipmentId;
    }

    let activeBrokerJob =
      brokerJobList.length > 0 &&
      brokerJobList.find(
        (item) =>
          removePSCEnding(get(item, "shipmentId", "")) === removePSCEnding(get(currentJobData, "shipmentId", ""))
      );

    let jobWheel = getJobWheels(shipmentCountry, activeBrokerJob);
    let bhHouseKey = jobWheel["SHIPMENT_BROKER_HOUSE_PROCESS"]
      ? jobWheel["SHIPMENT_BROKER_HOUSE_PROCESS"].value.state
      : null;
    let isAssigned = bhHouseKey === "STATE_BH_ASSIGNED";
    let bhFormDisabled = false;
    if (
      isAssigned ||
      get(kxUserBasicInfo, "userGuid", "") !==
      get(activeBrokerJob, "brokerGuid", "")
    ) {
      bhFormDisabled = true;
    }
    if (bhHouseKey === "STATE_BH_BROKER_DONE") {
      bhFormDisabled = false;
    }

    cwStatus = jobWheel["CW_JOB_WHEEL"]?.value?.state;

    if (formLoaded) {
      setFormValues(
        penClicked,
        setINPUTID,
        newValue,
        fieldName,
        rbCounterID,
        expandAll
      );
      var showallerrors = this.state.showallerrors;
      var maxErrorsShown = 3;

      let displayMsgWarning = (warning)=>{
        if(warning.boldThisPart){
          return <>{(warning.msg||"").split(" ").map((wordInMsg,iiioi) =>(
              <span style={warning.boldThisPart.includes(wordInMsg)?{fontWeight:'bold'}:{}} key={wordInMsg +"ccc"+iiioi}>{wordInMsg}  </span>
              ))}
          </>
        }
        return warning.msg;
      }

      if(pscChainRawResponse?.activeChildId && pscChainRawResponse?.activeChildId != shipmentId && !window.GLOBAL_HAS_REDIRECTED_USING_PSCCHAIN){
        window.GLOBAL_HAS_REDIRECTED_USING_PSCCHAIN=true;
        this.props.getClickedShipId(pscChainRawResponse?.activeChildId);
        this.createEntrySummary({
          shipId: pscChainRawResponse?.activeChildId,
          isChainMode: true
        }, "pscMode")
      } else if(pscChainRawResponse?.activeChildId){
        window.GLOBAL_HAS_REDIRECTED_USING_PSCCHAIN=true;
      }


      let boundingBoxMarginTop = 0;
      let formContentarea_bc = document.getElementsByClassName("formContentarea_bc");
      if(formContentarea_bc?.length && formContentarea_bc[0] && formContentarea_bc[0].getBoundingClientRect){
        boundingBoxMarginTop = parseInt(formContentarea_bc[0].getBoundingClientRect()?.top)
        if(boundingBoxMarginTop){boundingBoxMarginTop += 25;}
      }

      return (
        <Grid
          id="tabContainer"
          className="tabContainer"
          style={{ width: "100% !important" }}
        >
        {tariffsLoader ? <div 
          className='loader' 
          style={{
            fontSize:"large",
            display:"flex",
            justifyContent:"center",
            alignItems:"center",
            height:"100%", 
            width:"100%", 
            position:"absolute", 
            zIndex:'4',
            background: "white",
            opacity: "0.5",
            backdropFilter: "blur(20px)",
            WebkitBackdropFilter: "blur(20px)", // for Safari support
        }} >  <Loader active><b>Loading Tariffs...</b></Loader></div>: null}
          <div className="main-body">
            <div className="test-info">
              <div className="entry-summary CBP_ES">
                {/* {thisStatee && thisStatee.FieldValidation && thisStatee.FieldValidation.warnings.map((asinglewarnmsg, index) => (
                    <div >
                      {asinglewarnmsg && asinglewarnmsg.msg}
                    </div>
                  ))
                } */}
                <div className="tab-panel">
                  <div className="actualTabs">
                  {formTabNameSections.map((section, index) => {
                    
                    return(
                    <a
                      href="#"
                      key={index}
                      style={{ float: "left", zIndex: index + 5 }}
                      className={
                        section.warningClassListN.join(" ") +
                        " accordian-section xyTabStyle tab-content " +
                        section.title +
                        (activeAccordianIndex === index && !expandAll
                          ? " activeTabm "
                          : " ") +
                        section.className +
                        (section.warnings.length > 0 ? " warn " : " ")
                      }
                      onClick={() => {
                        localStorage.setItem("lastTabChoseb", index);
                        this.setActiveAccordianIndex(index);
                        this.validateForm_zz(true);
                        if (section.title == "Line Items") {
                          localStorage.setItem("useAggregateOnUi", "false")
                        }
                        if (section.title == "Aggregated") {
                          localStorage.setItem("useAggregateOnUi", "true")
                        }
                        if (activeAccordianIndex !== index && this.props.entryTypeValues?.useAggregated == "true" && ["Aggregated", "Line Items"].includes(section.title)) {
                          this.createEntrySummary();
                        }
                        
                      }}
                      onKeyPress={(e) => {
                        this.setActiveAccordianIndex(index);
                        this.validateForm_zz(true);
                        e.preventDefault();
                      }}
                    >
                      <div className="cornerimg">
                        <div></div>
                      </div>
                      <div className="title">
                        {section.title}
                        {section.warnings.filter(a => a.warntype != 'warning').length ? (
                          <div className="errorCircle">
                            {section.warnings.filter(a => a.warntype != 'warning').length}
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                      <div className="redline"></div>
                    </a>
                  )})}

                  {(this.state.PSC_PARENT ||
                    this.props.pscData.pscShipmentId) && (
                      <Button.Group className="esPscBtn">
                        <Button
                          className={this.state.PSC_PARENT ? "selected" : ""}
                          onClick={this.swtichToPSCParent.bind(this, "esMode")}
                        >
                          ES
                        </Button>
                        <Button
                          className={!this.state.PSC_PARENT ? "selected" : ""}
                          onClick={this.createEntrySummary.bind(this, false, "pscMode")}
                        >
                          PSC
                        </Button>
                      </Button.Group>
                    )}
                  </div>
                  

                  {formTabNameSections.map((section, index) => {
                    if (showallerrors) maxErrorsShown = section.warnings.length;
                    if (activeAccordianIndex != index) return null;
                    return (
                      <React.Fragment key={index}>
                        {
                          <div
                            className={
                              "warningBoxAboveFormcontentarea " +
                              (false ? " warn " : " nowarn ")
                            }
                          >
                            {
                              section.warnings.length > 0 ? (
                                this.state.hideError === true ? (
                                  <div
                                    style={{ color: "red", cursor: "pointer" }}
                                    onClick={this.showErrorList}
                                  >
                                    <div className={`errorLine`}></div>&nbsp;
                                    <Icon
                                      name="plus circle"
                                      style={{ display: "inline" }}
                                    />
                                    Expand&nbsp;Errors
                                  </div>
                                ) : (
                                  <div
                                    style={{ color: "red", cursor: "pointer" }}
                                    onClick={this.hideErrorList}
                                  >
                                    <div className={`errorLine`}></div>&nbsp;
                                    <Icon
                                      name="minus circle"
                                      style={{ display: "inline" }}
                                    />
                                    Collapse&nbsp;Errors
                                  </div>
                                )
                              ) : (
                                ""
                              )}
                            {section.warnings.length > 0 && (
                              <div
                                className={`ui error message ${this.state.hideError === true
                                  ? " hideError"
                                  : ""
                                  }`}
                              >
                                <div className="content">
                                  <ul className="list">
                                    {section.warnings.map(
                                      (bbbbwarning, ioiii) => {
                                        if (bbbbwarning.shown === false)
                                          return null;
                                        if (ioiii >= maxErrorsShown)
                                          return null;
                                        return (
                                          <li className="content" key={ioiii}>
                                            <div>
                                              {bbbbwarning.targetName_c ? (
                                                <a
                                                  className={`warningLink warnType${bbbbwarning.warntype}`}
                                                  href={"javascript:void(0)"}
                                                  // href={
                                                  //   "#" +
                                                  //   bbbbwarning.targetName_c
                                                  // }
                                                  onClick={() => {
                                                    const anchor = document.querySelector('a[name="'+bbbbwarning.targetName_c+'"]');
                                                    const containerDiv = document.querySelector("#sv-rnd");
                                                    const expandBtn = document.querySelectorAll(".expandButtoni")[0];
                                                    const drawer = document.querySelectorAll(".userfees_wr")[0];
                                                    
                                                    containerDiv.style.setProperty('padding-top', '45px', 'important');
                                                    expandBtn.style.setProperty('top', '55px', 'important');
                                                    drawer.style.setProperty('bottom', '2px', 'important');

                                                    if (anchor) {
                                                      anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
                                                    }
                                                    let invoiceToggleLink = document.getElementById(
                                                      "plus-" +
                                                      bbbbwarning.invoice
                                                    );
                                                    invoiceToggleLink &&
                                                      invoiceToggleLink.click();
                                                    setTimeout(() => {
                                                      let toggleLink = document.getElementById(
                                                        "plus-" +
                                                        bbbbwarning.targetName_c
                                                      );
                                                      toggleLink &&
                                                        toggleLink.click();
                                                    }, 1000);
                                                  }}
                                                >
                                                  <table>
                                                    <tbody>
                                                      <tr>
                                                        <td>
                                                          <span>
                                                            {
                                                              bbbbwarning.location && <>
                                                                {bbbbwarning.location}
                                                                :&nbsp;
                                                              </>
                                                            }
                                                          </span>
                                                        </td>
                                                        <td>
                                                        {displayMsgWarning(bbbbwarning)}
                                                        </td>
                                                      </tr>
                                                    </tbody>
                                                  </table>
                                                </a>
                                              ) : (
                                                <span
                                                  className={`warnType${bbbbwarning.warntype}`}
                                                >
                                                  
                                                  {displayMsgWarning(bbbbwarning)}
                                                </span>
                                              )}
                                              {!(
                                                maxErrorsShown >
                                                section.warnings.length
                                              ) &&
                                                ioiii + 1 == maxErrorsShown &&
                                                (showallerrors ||
                                                  section.warnings.length -
                                                  maxErrorsShown >
                                                  0) && (
                                                  <a
                                                    href="#"
                                                    onClick={() =>
                                                      this.maxErrorsShownToggle()
                                                    }
                                                  >
                                                    &nbsp; &nbsp; &nbsp;
                                                    {!showallerrors ? (
                                                      <span>
                                                        ...
                                                        {section.warnings
                                                          .length -
                                                          maxErrorsShown}{" "}
                                                        more
                                                      </span>
                                                    ) : (
                                                      <span>
                                                        &nbsp; &nbsp; &nbsp;
                                                        ...less
                                                      </span>
                                                    )}
                                                  </a>
                                                )}
                                            </div>
                                          </li>
                                        );
                                      }
                                    )}
                                  </ul>
                                </div>
                              </div>
                            )}
                          </div>
                        }
                        {
                          cwStatus !== "STATE_CW_OVERRIDE_FILED" && cwStatus !== "STATE_CW_OVERRIDE_ACCEPTED" && fieldValidationField.length &&
                            CW &&
                            Object.keys(CW).length > 0 ? (<>
                              {!this.state.expandbutton ? <div
                                style={{ color: "#1765ae", cursor: "pointer" }}
                                onClick={() => this.setState({
                                  expandbutton: !this.state.expandbutton
                                })}
                              >
                                <div className="errorLineForCensusWarning"></div>&nbsp;
                                <Icon
                                  name="plus circle"
                                  style={{ display: "inline" }}
                                />
                                Expand&nbsp;Census&nbsp;Warnings
                              </div>
                                : (
                                  <div
                                    style={{ color: "#1765ae", cursor: "pointer" }}
                                    onClick={() => this.setState({
                                      expandbutton: !this.state.expandbutton
                                    })}
                                  >
                                    <div className={`errorLineForCensusWarning`}></div>&nbsp;
                                    <Icon
                                      name="minus circle"
                                      style={{ display: "inline" }}
                                    />
                                    Collapse&nbsp;Census&nbsp;Warnings
                                  </div>
                                )}

                              {this.state.expandbutton == true && <div
                                className={
                                  (_.get(this.props, "esUsState.value.state", "").includes("IN_PROCESS") ||
                                    _.get(this.props, "esUsState.value.state", "").includes("READY"))
                                    ? `censusWarningBox`
                                    : `censusWarningBox disbleForm`
                                }
                              >
                                {this.props.formLoaded && this.censusWarningsList(CW)
                                  .sort((a, b) => a.lineItemIndex - b.lineItemIndex)
                                  .sort((a, b) => a.invoiceIndex - b.invoiceIndex)
                                  .map((cwitemx, index) => {
                                    return cwitemx.reacthtmlobject
                                  })}
                              </div>}
                            </>
                          ) : (
                            ""
                          )
                        }



                        <div
                          className="formContentarea_bc"
                          style={{
                            height:
                              "calc(100vh - " +(
                              boundingBoxMarginTop?boundingBoxMarginTop:(320 +
                                (getQueryVariable("onlyOneShipment")?0-50:0)+
                                (this.state.drawerIsOpen ? 0 : 0 - 140) +
                                (section.warnings.length ? 40 : 0) +
                                (section.warnings.length > maxErrorsShown
                                  ? maxErrorsShown
                                  : section.warnings.length) *
                                23)
                              ) +
                              "px)",
                          }}
                        >
                        { (pscChainRawResponse?.child || []).find(aaa=>!aaa.archived) && 
                        <>
                        <br/>
                        <div className="pscSelectorDropdown" style={{width:'250px'}}><span style={{color:'#99ff99',fontWeight:'bold'}}>
                            {(pscChainRawResponse?.child || []).map(aaa=>aaa.humanReadableId).includes(shipmentId)?<>PSC:&nbsp;</>:<></>}
                            </span><Dropdown 
                            text={shipmentId}
                            options={[]
                              .concat(pscChainRawResponse?.root?.humanReadableId)
                              .concat((pscChainRawResponse?.child||[]).filter(aaa=>!aaa.archived).map(aaaa=>aaaa.humanReadableId))
                              .map((xxx, pscChainIndex)=>{return {value:{shipmentId:xxx, pscChainIndex:pscChainIndex}, key: xxx, text:xxx}})
                            }
                            // text={displayMasterItem(usStateOfDestCode, USStatesList)}
                            onChange={(event,data) => {
                              if(event?.type == "blur")return;//otherwise it runs just tabbing through
                              this.props.getClickedShipId(data.value.shipmentId);
                              this.createEntrySummary({
                                shipId: data.value.shipmentId,
                                isChainMode: true
                              }, data.value.pscChainIndex==0?"esMode":"pscMode")
                            }}
                          /></div></>}
                          <div
                            className={`${activeAccordianIndex === index
                              ? " esFormContainerii visible "
                              : " esFormContainerii "
                              } ${isBrokerKnAdmin && section.title !== "Notes"
                                ? "disableButton"
                                : ""
                              }`}
                            key={index}
                          >
                            {section.form({
                              setShipmentDocumentId:this.props.setShipmentDocumentId,
                              expandAll,
                              isDisabled: section.disableFormBelowThis?()=>{return true;}:this.isDisabled,
                              modeOfTransport: this.props.modeOfTransport,
                              shipmentETA: _.get(this.props.currentJobData, "eta.epochs", -999),
                            })}
                          </div>
                        </div>
                      </React.Fragment>
                    );
                  })}
                </div>
                <a
                  id="VALIDATE_FORM_BUTTON"
                  onClick={() => {
                    this.validateForm_zz(true);
                  }}
                >&nbsp;</a>
              </div>
            </div>
            <Toast errorMessage={errorMessage} />
          </div>
          <UserFees
            drawerIsOpen={this.state.drawerIsOpen}
            toggleDrawerOpen={this.toggleDrawerOpen}
            {...this.props}
          ></UserFees>
        </Grid>
      );
    } else if (formError) {
      if (formError.response && formError.config) {
        return (
          <center style={{ position: "relative", top: "30vh" }}>
            {"Entry could not load due to an error. Please retry again. If error persists, please contact KlearNow support with below details"}
            <br />


            <br /><br />{<a onClick={() => { this.setState({ showFullDataResponse: !this.state.showFullDataResponse }) }}>Show Technical Details</a>}<br /><br />

            {this.state.showFullDataResponse && JSON.stringify(formError.response).replaceAll(/kxToken":"[^"]*"/g, "kxToken\":\"\"")}
            <br />
            <br />
            {this.state.showFullDataResponse && formError.config.data}
          </center>
        );
      } else {
        let currentErrorMessage ="No error";
        if(this.state?.fullDataResponse?.data?.eventMessage?.msg){
          currentErrorMessage = this.state?.fullDataResponse?.data?.eventMessage?.code+": "+this.state?.fullDataResponse?.data?.eventMessage?.msg;
        } else if(this.state?.fullDataResponse?.message){
          currentErrorMessage = this.state?.fullDataResponse?.message;
        }
        return (
          <center style={{ position: "relative", top: "30vh" }}>
            {"Entry could not load due to an error. Please retry again. If error persists, please contact KlearNow support with below details"}
            {!!responseObjectff.msg && <><br /><b>
              {responseObjectff.code && <>{responseObjectff.code}:&nbsp;</>}
              {responseObjectff.msg}
            </b></>}
            <br />
            {currentErrorMessage && <>
              <br /><br />{<a onClick={() => { this.setState({ showFullDataResponse: !this.state.showFullDataResponse }) }}>Show Technical Details</a>}<br /><br />
            </>}
            {this.state.showFullDataResponse && <>
              {currentErrorMessage ? <><br />{currentErrorMessage + ""}<br /></> : "No details returned."}
              <br/>
              {this.state.formLevelError?this.state.formLevelError+"":""}
            </>}

          </center>
        );
      }
    } else {
      return (
        <center style={{ position: "relative", top: "30vh" }}>
          Preparing Entry Release &amp; Summary{" "}
          <Loader indeterminate active inline size="small" />
        </center>
      );
    }
  }
}

const mapStateToProps = (state) => ({
  // activeTSCAMerchandiseId: state.TSCA.activeTSCAMerchandiseId,
  // activeFDAMerchandiseId: state.FDA && state.FDA.activeFDAMerchandiseId,
  formLoaded: state.FormValues.formLoaded,
  formError: state.FormValues.error,
  pscChainRawResponse: state.PscChainRawResponse,
  errorMessage: state.FormValues.errorMessage,
  entryTypeValues: state.EntryTypeInfo,
  fieldValidation: state.FieldValidation,
  bolInfoValues: state.BOLInfo,
  censusWarnings: state.FieldValidation.census_warnings,
  invoiceData: state.DescriptionOfMerchandise.entrySummaryInvoices,
  merchandiseData: state.DescriptionOfMerchandise.merchandiseLineItems,
  modeOfTransport_MOT: state.TransportationInfo.modeOfTransport,
  transportationInfo: state.TransportationInfo,
  pscData: state.PSC,
  reconInfo: state.ReconInfo,
  tariffsLoader:  state.DescriptionOfMerchandise.tariffsLoader,

});

const mapDispatchToProps = {
  ...actionCreators,
};

export default connect(mapStateToProps, mapDispatchToProps)(EntrySummaryForm);
